import React, { useState } from "react";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector, useDispatch } from "react-redux";
import Label from "../bigScreens/Label";
import BSNavBar from "../bigScreens/BSNavBar";
import ArSubCheckout from "./ArSubCheckout";

const promise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const ArSubscription = () => {
  const [Zindex, setZindex] = useState(1);
  const { user, useCoupon, cart } = useSelector((state) => ({ ...state }));

  const ChangeZindex = (click) => {
    if (click) {
      setZindex(0);
    } else {
      setZindex(1);
    }
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "0px",
      }}>
      <div>
        <Label ChangeZindex={ChangeZindex} />
      </div>
      <div>
        <BSNavBar withSearch={false} Zindex={Zindex} />
      </div>
      <div>
        <Elements stripe={promise}>
          <div>
            {/* <BsStripeCheckout /> */}
            <ArSubCheckout />
          </div>
        </Elements>
      </div>
    </div>
  );
};

export default ArSubscription;
